import antdTr from "antd/lib/locale-provider/tr_TR";
import enMessages from "../locales/tr_TR.json";

const TrLang = {
  messages: {
    ...enMessages
  },
  antd: antdTr,
  locale: 'en-TR',
};
export default TrLang;
